export default "__VITE_ASSET__DQ4gV4CV__"